import { render, staticRenderFns } from "./pasarDebitarAimpactar.vue?vue&type=template&id=0bb71b40"
import script from "./pasarDebitarAimpactar.vue?vue&type=script&lang=js"
export * from "./pasarDebitarAimpactar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports